import styled from 'styled-components';
import { BaseButton } from '@stelecom/ui-react/components/buttons/baseButton';
import { COLORS, FONTS } from '@stelecom/ui-react/assets/js/constants';
import { TopMenuItem } from '~/src/components/Header/styled';
import { breakpoints } from '~/src/components/Header/styled';
import { CitySelect as CitySelectRight } from '../RightMenu/styled';

export const Button = styled(BaseButton)`
  align-self: center;
  margin-left: 16px;

  @media (max-width: ${breakpoints.sDesktop}) {
    margin-left: 0;
  }
`;

export const MenuItem = styled(TopMenuItem)<{ isPromoted?: boolean }>`
  margin-right: 16px;

  @media (max-width: ${breakpoints.sDesktop}) {
    display: none;
  }
`;

export const Link = styled.a`
  color: ${COLORS.PINK_BRIGHT};
`;

export const MainMenuWrap = styled.div`
  flex-wrap: nowrap;
  height: 100%;
  display: flex;
  align-items: center;

  @media (max-width: ${breakpoints.sDesktop}) {
    display: none;
  }
`;
export const MainMenuPayment = styled.div`
  padding: 14px 55px 10px 55px;
  max-height: 45px;
  background-color: ${COLORS.PINK_BRIGHT};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 24px;
  p {
    color: ${COLORS.WHITE};
  }
`;
export const Item = styled.div`
  ${FONTS.XS};
  color: ${COLORS.black};
  cursor: pointer;
`;

export const CitySelect = styled(CitySelectRight)`
  display: block !important;
`;

export const CityWrapper = styled.div`
  display: none;
  margin-right: 35px;
  margin-bottom: auto;
  margin-top: auto;

  @media (max-width: ${breakpoints.sDesktop}) {
    display: flex;
  }

  @media (max-width: ${breakpoints.mobile}) {
    display: none;
  }
`;

export const LoginWrapper = styled.div`
  display: none;
  align-self: flex-end;
  margin: auto 16px auto 0;

  @media (max-width: ${breakpoints.sDesktop}) {
    display: flex;
  }

  @media (max-width: ${breakpoints.mobile}) {
    display: none;
  }
`;

export const Profile = styled.a`
  align-self: center;
  ${FONTS.Medium};
  color: ${COLORS.black};
  position: relative;
  padding-right: 6px;
  transition: color 0.3s ease;

  @media (max-width: ${breakpoints.mobile}) {
    margin-right: 0;
    ${FONTS.Medium};
  }

  &:hover {
    color: ${COLORS.red};
  }
`;

export const ProfileAuth = styled.div`
  position: relative;
  transition: 0.3s color ease;
  cursor: pointer;
  flex-wrap: nowrap;
  ${FONTS.XS};

  &:hover {
    color: ${COLORS.red};
  }

  &:hover > div {
    height: auto;
    display: flex;
    padding: 22px 16px 16px;
  }

  @media (max-width: ${breakpoints.tablet}) {
    margin-left: 16px;
  }
  
  @media(max-width: ${breakpoints.mobile}){
    ${FONTS.XXS};
    /* margin-right: 4px; */
    max-width: 170px;
  }
`;

export const Name = styled.span`
  align-self: center;
  padding-right: 12px;
  ${FONTS.XS};
  white-space: nowrap;

  @media (max-width: ${breakpoints.mobile}) {
    display: none;
  }
`;

export const ProfileAuthWrapper = styled.span`
  display: none;
  height: 38px;

  @media (max-width: ${breakpoints.sDesktop}) {
    display: flex;
  }

  @media (max-width: ${breakpoints.mobile}) {
    display: flex;
  }
`;
